"use client";

// Own client module: rendering next/image straight from the server Footer made every page load the homepage's chunks.
import Image, { StaticImageData } from "next/image";

const FooterLogo = ({ src }: { src: StaticImageData }) => (
  <Image
    fill
    src={src}
    alt="innovation-logo"
    sizes="(max-width: 208px) 100vw"
    placeholder="blur"
    priority
    className="object-cover object-center"
  />
);

export default FooterLogo;
